export default __webpack_public_path__ + "static/media/GR4 2A-1C-1D-2EC.5951de1f.jpg";